import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { imageName, productImageUrl } from './mobileProductUtils';
import ProductDiscountImage from '../../../ProductDiscountImage';

export default function MobileProductThumbnail({ product }) {
  const image = (product.images || []).find(item => item?.sortOrder === 0) || product.images?.[0];
  const name = imageName(image);
  const [failedSource, setFailedSource] = useState(null);
  const src = name ? productImageUrl(name) : '';
  return (
    <Link
      to={`/product/${product.id}`}
      className='mp-product-thumbnail'
      aria-label={`Переглянути ${product.name}`}
    >
      <ProductDiscountImage discountPercent={product.discount} className='mp-thumbnail-discount'>
        {src && src !== failedSource ? (
          <img src={src} alt={product.name} loading='lazy' onError={() => setFailedSource(src)} />
        ) : (
          <span className='mp-image-placeholder'>
            <i className='bi bi-image' aria-hidden='true' />
            <span>Немає фото</span>
          </span>
        )}
      </ProductDiscountImage>
    </Link>
  );
}
